export default "__VITE_ASSET__CarTmUeJ__"